import React,{useState, useEffect} from 'react';
import moment from 'moment';
import {Table, Select, Skeleton } from 'antd';
import { getData } from '../../config/api-connect';
import * as Styled from './style.js';
import { ArrowRightOutlined } from '@ant-design/icons';
import {Link} from 'react-router-dom';

const { Option } = Select;

const RetentionAnalysis = () => {
  var local_city = JSON.parse(localStorage.getItem('cityId'))
  var local_selectedVenueId = JSON.parse(localStorage.getItem('selectedVenueId'))
  if(!local_selectedVenueId){
    local_selectedVenueId = 'All'
  }

  var local_game_type = JSON.parse(localStorage.getItem('gameType'))
  if(!local_game_type){
    local_game_type = 8
  }

	const [loading, setLoading] = useState(true)
	const [venues, setVenues] = useState([])
  const [cities, setCities] = useState([])
	const [cityId, setCityId] = useState(local_city)
	const [selectedVenueId, setSelectedVenueId] = useState(local_selectedVenueId)
	const [venuelist, setVenuelist] = useState([])
  const [gameType, setGameType] = useState(local_game_type)
  const [retentionData,setRetentionData] = useState([])

  useEffect(() => {
    localStorage.setItem('selectedVenueId',JSON.stringify(selectedVenueId))
    localStorage.setItem('cityId',JSON.stringify(cityId))
    localStorage.setItem('gameType',JSON.stringify(gameType))
    if(cityId && selectedVenueId && gameType) {
			getRetentionAnalysis()
		}
  }, [selectedVenueId,cityId,gameType]);

	useEffect(() => {
		getVenues()
	}, []);

	useEffect(() => {
		if(cities.length){
			getVenuesInCity()
		}
	}, [cities,cityId]);

	const handleCityChange = (value) => {
		if (value.length > 0) {
		  const last_selected = value[value.length - 1]
		  if(last_selected === 'All'){
		    setCityId(['All']);
		  }
		  else{
		    const filtered = value.filter(v => v !== 'All');
		    setCityId(filtered)
		  }
		}
		else {
		  setCityId(['All']);
		}
	};

	const getVenuesInCity =() =>{
		if(cities[0] && !cityId){
		  setCityId([cities[0].id])
		}

		let filteredVenues;

		if (cityId === 'All' || (Array.isArray(cityId) && cityId.includes('All')) ) {
		  filteredVenues = venues;
		} else {
		  filteredVenues = Array.isArray(cityId) ? venues.filter(item => cityId.includes(item.city)) : venues ;
		}

		setVenuelist(filteredVenues);
		const venueExists = filteredVenues.some(item => item.id === selectedVenueId);
		if (!venueExists) {
		  setSelectedVenueId('All');
		}
	}

	const getVenues = async () => {
		await getData('/business/get_venues_for_buddies/')
		.then(response =>{
		  setVenues(response.result)
		  setCities(response.cities)
		})
		.catch(error => {
		  setLoading(false)
		  console.log(error.message);
		});
	}

	const getRetentionAnalysis = async () => {
		setLoading(true)
		await getData(`/business/get_retention_analysis/?venue_id=${selectedVenueId}&city_id=${cityId}&game_type_id=${gameType}`)
		.then(response =>{
		  setRetentionData(response.result)
		})
		.catch(error => {
		  console.log(error.message);
		})
		.finally(()=> {
			setLoading(false)
		})
	}

	const renderHeader = (label,hasInfo) => {
    return(
	      <span>{label}</span>
    )
  } 

  const renderRetentionColumn = (field) => {
  	return(
  			field ?
  				<Styled.RetentionField value={field.percent}>
	  				{field.customers} 
  				</Styled.RetentionField>
  			: 
  				<span>-</span>
  	)
  }

	const columns = [
    {
      title: renderHeader('Month',false),
      dataIndex: 'month',
      key: 'month',
		  align: 'center',
		  width:'20%',
  		render: (text) => <div>{moment(text, 'MMMM YYYY').format('MMM YYYY')}</div>
    },
    {
      title: renderHeader('New Customers',true),
      dataIndex: 'new_customers',
      key: 'new_customers',
		  align: 'center',
		  width:'20%',
		  render: (value,record) => {
      	const monthYear = moment(record.month, 'MMMM YYYY').format('MM-YYYY');
        return(
          <Link to={`/retention-analysis/new/${monthYear}`} className='venueTitle' 
                style={{display:'flex',gap:'5px',alignItems:'center',justifyContent:'center'}}>
          	{value} <ArrowRightOutlined style={{fontSize: 'xx-small'}} />
          </Link>
          )
      },
    },
    {
      title: renderHeader('Retained After 3 Months',true),
      dataIndex: 'three_month_retention',
      key: 'three_month_retention',
		  align: 'center',
		  width:'20%',
		  onCell: () => ({
		    style: { padding: 0 }
		  }),
		  render: (value) => renderRetentionColumn(value) 
    },
    {
      title: renderHeader('Retained After 6 Months',true),
      dataIndex: 'six_month_retention',
      key: 'six_month_retention',
		  align: 'center',
		  width:'20%',
		  onCell: () => ({
		    style: { padding: 0 }
		  }),
		  render: (value) => renderRetentionColumn(value) 
    },
    {
      title: renderHeader('Retained After 12 Months',true),
      dataIndex: 'twelve_month_retention',
      key: 'twelve_month_retention',
		  align: 'center',
		  width:'20%',
		  onCell: () => ({
		    style: { padding: 0 }
		  }),
		  render: (value) => renderRetentionColumn(value) 
    },
  ]

	return (
    <Styled.MainContainer>
      <Styled.TopDiv>    
        <Styled.SelectorContainer>

          {cities.length > 1 &&         
            <Styled.Selector>
              <span className='indicatorText'>City</span>
              <Select
                mode="multiple"
                className = 'mainSelector'
                style={{width: 150}}
                showSearch = {true}
                placeholder="Search to Select"
                optionFilterProp="children"
                filterOption={(input, option) => option.name.toLowerCase().includes(input.toLowerCase())}
                onChange={handleCityChange}
                value = {cityId}
                bordered={false}
              >
                <Option value="All" name="All"> All </Option>
                {
                  cities.map(item=>(
                    <Option value={item.id} key={item.id} name = {item.name}> {item.name} </Option>    
                  ))
                }
              </Select>
            </Styled.Selector>
          }
          {venuelist && venuelist.length > 0 &&
	          <Styled.Selector>
	            <span className='indicatorText'>Venue</span>
	            <Select
	              className = 'mainSelector'
	              style={{width: 300}}
	              showSearch = {true}
	              placeholder="Search to Select"
	              optionFilterProp="children"
	              filterOption={(input, option) => option.name.toLowerCase().includes(input.toLowerCase())}
	              onChange={setSelectedVenueId}
	              value = {selectedVenueId}
	              bordered={false}
	            >
	              <Option value="All" name="All"> All </Option>
	              {venuelist.map(item=>(
	                <Option value={item.id} key={item.id} name = {item.name}> {item.name} </Option>    
	                ))
	              }
	            </Select>
	          </Styled.Selector>
          }

          <Styled.Selector>
            <span className='indicatorText'>Program</span>
            <Select
                className = 'mainSelector'
                style={{width: 210}}
                onChange={setGameType}
                value = {gameType}
                bordered={false}
              >
                <Option value="8"> Football Academy </Option>
                <Option value="10"> Badminton Academy </Option>
                <Option value="65"> Swimming Academy </Option>
                <Option value="44"> Tennis Academy </Option>
              </Select>
          </Styled.Selector>
        </Styled.SelectorContainer>
      </Styled.TopDiv>
      <Styled.Header>          
        <span> Customer Retention Analysis </span>
      </Styled.Header>
      {loading ?
        <Skeleton active paragraph={{ rows: 7 }} title={false} />
      :
	      <Table
					className="table_container"
					tableLayout="fixed"
					rowKey="id"
					columns={columns}
					dataSource={[...retentionData].reverse()}
					pagination={false}
          scroll={{ x: 'max-content' }}

				/>
			}
    </Styled.MainContainer>
  );
}

export default RetentionAnalysis